import React, { Component } from 'react';
import { matchPath } from 'react-router';
import api from 'services/api';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as JourneysActions } from 'store/ducks/journeys';

import { Page, Loading } from 'components';

class MagicLink extends Component {
  async componentDidMount() {
    const { location } = this.props;
    const match = matchPath(location.pathname, { path: '/magiclink/:id' });

    const response = await api.get(`auth/users/magiclink/${match.params.id}`);
    const { interview_id, jwt } = response.data;

    await localStorage.setItem('auth_token', jwt);

    this.loadInterview(interview_id);
  }

  loadInterview = async id => {
    const { history } = this.props;

    const response = await api.get(`search/interviews/${id}`);
    const { data } = response.data;

    const type = data.attributes.interviewable_type;

    switch (type) {
      case 'NorthFace::Quiz':
        history.push(`/journey/${id}/north`);
        break;
      case 'EastFace::Quiz':
        history.push(`/journey/${id}/east`);
        break;
      case 'WestFace::Quiz':
        history.push(`/journey/${id}/west`);
        break;
      case 'SouthFace::Quiz':
        history.push(`/journey/${id}/south`);
        break;
      default:
        // TODO ADD CONDITIONAL VERIFICATION TO CORRECT REDIRECT.
        history.push(`/journey/${id}/south`);
    }
  };

  render() {
    return (
      <Page>
        <Loading />
      </Page>
    );
  }
}

const mapState = state => ({
  // user: state.auth.user,
});

const mapActions = dispatch => bindActionCreators(JourneysActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(MagicLink);



// WEBPACK FOOTER //
// ./src/pages/MagicLink/index.js